<template>
  <a-input
    ref="inputRef"
    type="text"
    class="text-lg rounded-r-none"
  />
</template>

<script>
import { watch, watchEffect } from '@vue/composition-api'
import useCurrencyInput from 'vue-currency-input'

export default {
  name: 'CurrencyInput',
  props: {
    value: {
      type: Number,
      default: null,
    },
    currency: {
      type: String,
      required: true,
    },
    currencyDisplay: {
      type: String,
      required: true
    },
  },
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setup(props) {
    const { currencyDisplay, currency } = props
    const { inputRef, setValue, setOptions } = useCurrencyInput({ currencyDisplay, currency })

    watchEffect(() => setOptions({ currency: props.currency }))

    watch(
      () => props.value,
      (value) => {
        setValue(value)
      },
    )
    return { inputRef }
  },
}
</script>
